import gql from 'graphql-tag'
import { graphql, ChildDataProps } from 'react-apollo'

export type InputProps = {}

export type Variables = {}

export type Response = {}

type ChildProps = ChildDataProps<InputProps, Response, Variables>

export const USER_DATA_QUERY = gql`
  query {
    getUserData {
      company
      companyType
      street
      zipCode
      city
      country
      webAdress
      employeeCount
      sex
      firstname
      lastname
      phone
      fax
      email
      dealer
    }
  }
`

const withUserDataQuery = graphql<InputProps, Response, Variables, ChildProps>(USER_DATA_QUERY)

export default withUserDataQuery
